// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_react-query_devtools_index_js":"8a9a5abd1886ded75f3c","packages_translations_src_locales_en-CA_ts":"feb1927a46da25e6926e"}[chunkId] + ".chunk.js";
};